"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ListObjectsV2Input_1 = require("./ListObjectsV2Input");
var ListObjectsV2Output_1 = require("./ListObjectsV2Output");
var NoSuchBucket_1 = require("./NoSuchBucket");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.ListObjectsV2 = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "ListObjectsV2",
    http: {
        method: "GET",
        requestUri: "/{Bucket}?list-type=2"
    },
    input: {
        shape: ListObjectsV2Input_1.ListObjectsV2Input
    },
    output: {
        shape: ListObjectsV2Output_1.ListObjectsV2Output
    },
    errors: [
        {
            shape: NoSuchBucket_1.NoSuchBucket
        }
    ]
};
//# sourceMappingURL=ListObjectsV2.js.map